module.exports = __webpack_public_path__ + "static/media/rm_06-06.45e000b7.png";